import { h, Component } from 'preact'

import classList from '../etc/classList.js'

const VALIDATORS = [
	'badInput',
	'patternMismatch',
	'rangeOverflow',
	'rangeUnderflow',
	'stepMismatch',
	'tooLong',
	'tooShort',
	'typeMismatch',
	'valueMissing',
]

export default class Input extends Component {

	componentDidMount() {
		if (this.base && this.props.errors) {
			this.base.addEventListener('input', this.handleValidInput)
		}
	}

	handleValidInput = event => this.base && this.base.setCustomValidity('')

	// attached to 'oninvalid' event, if errors prop set

	handleInputErrors = event => {
		const { target } = event
		const { value, validity } = target
		const { errors } = this.props
		const validationKey = VALIDATORS.find(key => validity[key] === true)
		const customError = errors[validationKey]

		let error

		if (customError) {

			if (typeof customError === 'function') {
				switch (validationKey) {
					case 'badInput':
						error = customError(value, target.type)
						break
					case 'patternMismatch':
						error = customError(value, new RegExp(target.pattern))
						break
					case 'rangeOverflow':
						error = customError(Number(value), Number(target.max))
						break
					case 'rangeUnderflow':
						error = customError(Number(value), Number(target.min))
						break
					case 'stepMismatch':
						error = customError(Number(value), Number(target.step))
						break
					case 'tooLong':
						error = customError(value, Number(target.maxLength), value.length)
						break
					case 'tooShort':
						error = customError(value, Number(target.minLength), value.length)
						break
					case 'typeMismatch':
						error = customError(value, target.type)
						break
					case 'valueMissing':
						error = customError(value)
						break
				}
			} else {
				error = customError
			}

			event.target.setCustomValidity(error)
		}
	}

	render({ className:c = null, name, type, errors, ...etc }) {
		const className = classList('Input', c)

		return (
			<input
				class={ className() }
				name={ name }
				type={ type }
				oninvalid={ errors ? this.handleInputErrors : null }
				{ ...etc }
			/>
		)
	}
}
